var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _rect3, _path9, _path10, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle5, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle6, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenrecorder1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "screenrecorder-1_svg__Group_41143",
    "data-name": "Group 41143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 887,
    height: 814.407,
    viewBox: "0 0 887 814.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-1_svg__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11ebd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-1_svg__linear-gradient-3",
    x1: 0.5,
    x2: 0,
    y2: 0.809,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-1_svg__linear-gradient-4",
    x1: 1,
    y1: 0.133,
    x2: -0.403,
    y2: 1.312,
    xlinkHref: "#screenrecorder-1_svg__linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-1_svg__linear-gradient-7",
    x1: 0.5,
    y1: 0,
    x2: -1.66,
    y2: 0.712,
    xlinkHref: "#screenrecorder-1_svg__linear-gradient-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21186",
    "data-name": "Path 21186",
    d: "M349.1,675.795c-14.542,10.014-29.413,20.348-39.482,34.852s-14.464,34.3-6.374,50l-.209.978a37.848,37.848,0,0,0,36.548-6.438c12.8-10.744,16.814-28.445,20.08-44.835l9.659-48.479Z",
    transform: "translate(-287.151 49.18)",
    fill: "url(#screenrecorder-1_svg__linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21187",
    "data-name": "Path 21187",
    d: "M356.476,706.572c-9.7,2.146-19.64,4.39-27.958,9.824s-14.8,14.829-13.9,24.723l-.316.466a21.3,21.3,0,0,0,20.419,4.372c8.947-2.9,14.783-11.277,19.952-19.133l15.289-23.237Z",
    transform: "translate(-280.524 67.29)",
    fill: "url(#screenrecorder-1_svg__linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21188",
    "data-name": "Path 21188",
    d: "M1159.5,196.964H331.22a1.2,1.2,0,0,1,0-2.4H1159.5a1.2,1.2,0,1,1,0,2.4Z",
    transform: "translate(-273.703 -153.687)",
    fill: "#cacaca"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_382",
    "data-name": "Ellipse 382",
    cx: 13.224,
    cy: 13.224,
    r: 13.224,
    transform: "translate(71.351 0)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_383",
    "data-name": "Ellipse 383",
    cx: 13.224,
    cy: 13.224,
    r: 13.224,
    transform: "translate(117.032 0)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 13.224,
    cy: 13.224,
    r: 13.224,
    transform: "translate(162.713 0)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21189",
    "data-name": "Path 21189",
    d: "M899.88,173.155H867.422a2.4,2.4,0,1,1,0-4.809H899.88a2.4,2.4,0,0,1,0,4.809Z",
    transform: "translate(-41.452 -165.066)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21190",
    "data-name": "Path 21190",
    d: "M899.88,179.442H867.422a2.4,2.4,0,1,1,0-4.809H899.88a2.4,2.4,0,0,1,0,4.809Z",
    transform: "translate(-41.452 -162.337)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21191",
    "data-name": "Path 21191",
    d: "M899.88,185.729H867.422a2.4,2.4,0,1,1,0-4.809H899.88a2.4,2.4,0,0,1,0,4.809Z",
    transform: "translate(-41.452 -159.608)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-1_svg__Rectangle_13218",
    "data-name": "Rectangle 13218",
    width: 549.382,
    height: 329.389,
    transform: "translate(71.019 94.828)",
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-1_svg__Rectangle_13219",
    "data-name": "Rectangle 13219",
    width: 173.109,
    height: 103.79,
    transform: "translate(687.722 94.828)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21192",
    "data-name": "Path 21192",
    d: "M899.568,340.739h-103a4.851,4.851,0,1,1,0-9.7h103a4.851,4.851,0,0,1,0,9.7Z",
    transform: "translate(-73.273 -94.44)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21193",
    "data-name": "Path 21193",
    d: "M877.934,329.159H808.149a4.851,4.851,0,1,1,0-9.7h69.786a4.851,4.851,0,0,1,0,9.7Z",
    transform: "translate(-68.246 -99.467)",
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-1_svg__Rectangle_13220",
    "data-name": "Rectangle 13220",
    width: 173.109,
    height: 103.79,
    transform: "translate(687.722 283.566)",
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21194",
    "data-name": "Path 21194",
    d: "M899.568,472.344h-103a4.851,4.851,0,1,1,0-9.7h103a4.851,4.851,0,0,1,0,9.7Z",
    transform: "translate(-73.273 -37.309)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21195",
    "data-name": "Path 21195",
    d: "M877.934,460.764H808.149a4.851,4.851,0,1,1,0-9.7h69.786a4.851,4.851,0,0,1,0,9.7Z",
    transform: "translate(-68.246 -42.336)",
    fill: "#e4e4e4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_385",
    "data-name": "Ellipse 385",
    cx: 40.996,
    cy: 40.996,
    r: 40.996,
    transform: "translate(314.261 190.034)",
    fill: "#9e616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21196",
    "data-name": "Path 21196",
    d: "M327,338.638H224.2l5.769-129.988.71-.746,10.207-10.772h32.458l12.045,11.661.949.926,25.63,24.559Z",
    transform: "translate(97.331 85.578)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21197",
    "data-name": "Path 21197",
    d: "M558.726,501.6H480.6c-.517-49.745-.926-87.276-.926-87.276l3.992-2.428.024-.012,43.818-26.6,9.2-14.943.048.529,2.7,31.5S554.158,449.857,558.726,501.6Z",
    transform: "translate(-208.736 -77.38)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21198",
    "data-name": "Path 21198",
    d: "M632.005,501.6h-69.52c-3.715-16.854-5.65-32.9-4.809-46.283,3.414-54.662-4.46-84.98-1.046-84.98l1.8,1.419,21.446,16.938,28.239,10.35,19.595,7.189,3.414,1.25v1.647C631.139,417.4,631.224,455.807,632.005,501.6Z",
    transform: "translate(-175.709 -77.38)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21199",
    "data-name": "Path 21199",
    d: "M514.612,357.557s3.483-6.117,2.673-26.552,30.308-8.877,56.31-10.827,20.5,34.117,20.5,34.117,1.876-2.144,5.892-19.551-5.1-34.753-5.1-34.753c-2.686-18.291-17.16-12.429-17.16-12.429,6.97,2.714,5.632,8.516,5.632,8.516-5.9-10.345-20.374-4.482-20.374-4.482-19.3-12.114-38.869,3.839-38.869,3.839-23.32,5.293-9.644,23.838-9.644,23.838C491.015,331.125,514.612,357.557,514.612,357.557Z",
    transform: "translate(-198.14 -113.701)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21200",
    "data-name": "Path 21200",
    d: "M464.534,489.021c2-39.9,3.522-71.2,2.921-73.62-1.683-6.72,22.06-15.82,22.781-16.085l.012-.012h.012l4.532,2.44,3.318,87.276Z",
    transform: "translate(-215.308 -64.804)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21201",
    "data-name": "Path 21201",
    d: "M634.06,492.976H598.778l-10.1-99.743,4.159-3.041.986.228c3.234.805,13.669,3.534,19.595,7.189a11.874,11.874,0,0,1,3.414,2.9,3.493,3.493,0,0,1,.806,2.476C617.338,405.808,625.032,445.744,634.06,492.976Z",
    transform: "translate(-161.415 -68.76)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21202",
    "data-name": "Path 21202",
    d: "M776.187,489.945H403.521a5.41,5.41,0,1,0,0,10.819H776.187a5.41,5.41,0,1,0,0-10.819Z",
    transform: "translate(-244.143 -25.456)",
    fill: "#cacaca"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21203",
    "data-name": "Path 21203",
    d: "M675.206,489.945v10.819H403.521a5.41,5.41,0,1,1,0-10.819Z",
    transform: "translate(-244.143 -25.456)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 10.819,
    cy: 10.819,
    r: 10.819,
    transform: "translate(420.244 459.08)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screenrecorder-1_svg__Group_41144",
    "data-name": "Group 41144",
    transform: "translate(323.377 515.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21204",
    "data-name": "Path 21204",
    d: "M538.573,570.107a22.334,22.334,0,1,1,22.334-22.334,22.334,22.334,0,0,1-22.334,22.334Zm0-42.95a20.616,20.616,0,1,0,20.616,20.616,20.616,20.616,0,0,0-20.616-20.616Z",
    transform: "translate(-516.239 -525.439)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21205",
    "data-name": "Path 21205",
    d: "M530.015,556.679a.859.859,0,0,1-.859-.859V533.486a.859.859,0,1,1,1.718,0V555.82A.859.859,0,0,1,530.015,556.679Z",
    transform: "translate(-510.631 -522.32)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21206",
    "data-name": "Path 21206",
    d: "M534.129,556.679a.859.859,0,0,1-.859-.859V533.486a.859.859,0,1,1,1.718,0V555.82A.859.859,0,0,1,534.129,556.679Z",
    transform: "translate(-508.846 -522.32)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-4)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21207",
    "data-name": "Path 21207",
    d: "M460.483,547.772a22.334,22.334,0,1,1,22.334,22.335,22.334,22.334,0,0,1-22.334-22.335Zm1.718,0a20.616,20.616,0,1,0,20.616-20.615A20.616,20.616,0,0,0,462.2,547.772Z",
    transform: "translate(-217.067 -10.047)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21208",
    "data-name": "Path 21208",
    d: "M486.567,550.808a.714.714,0,0,0,.358-1.333l-10.715-6.186,10.715-6.186a.714.714,0,0,0-.714-1.237l-11.787,6.805a.715.715,0,0,0,0,1.238l11.787,6.8A.711.711,0,0,0,486.567,550.808Z",
    transform: "translate(-211.17 -5.563)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21209",
    "data-name": "Path 21209",
    d: "M471.978,554.041a.714.714,0,0,0,.714-.714V534.753a.714.714,0,0,0-1.429,0v18.573a.714.714,0,0,0,.714.714Z",
    transform: "translate(-212.386 -6.314)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21210",
    "data-name": "Path 21210",
    d: "M594.329,570.107a22.334,22.334,0,1,1,22.334-22.334,22.334,22.334,0,0,1-22.334,22.334Zm0-42.95a20.616,20.616,0,1,0,20.616,20.616,20.616,20.616,0,0,0-20.616-20.616Z",
    transform: "translate(-168.658 -10.047)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21211",
    "data-name": "Path 21211",
    d: "M581.059,550.809a.714.714,0,0,1-.358-1.333l10.715-6.186L580.7,537.1a.715.715,0,1,1,.714-1.238L593.2,542.67a.715.715,0,0,1,0,1.238l-11.787,6.805A.712.712,0,0,1,581.059,550.809Z",
    transform: "translate(-165.033 -5.563)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21212",
    "data-name": "Path 21212",
    d: "M592.078,554.041a.714.714,0,0,1-.714-.714V534.753a.714.714,0,0,1,1.429,0v18.573a.714.714,0,0,1-.714.714Z",
    transform: "translate(-160.249 -6.314)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21213",
    "data-name": "Path 21213",
    d: "M384.847,569.871a11.43,11.43,0,0,1,1.561-17.457l-10.988-39.1,20.107,6.42,7.352,36.149a11.492,11.492,0,0,1-18.032,13.992Z",
    transform: "translate(-253.994 -15.312)",
    fill: "#ffb6b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21214",
    "data-name": "Path 21214",
    d: "M383.7,418.213l-4.165-4.335s-12.878,8.845-10.153,36.264c2.013,20.253-4.347,28.841-3.636,87.707L383.7,591.76l20.766-10.886L389.44,514.356Z",
    transform: "translate(-258.219 -58.477)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-7)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21215",
    "data-name": "Path 21215",
    d: "M98.36,573.317h14.89l7.085-57.435H98.357Z",
    transform: "translate(42.698 223.952)",
    fill: "#ffb6b6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21216",
    "data-name": "Path 21216",
    d: "M386.461,718.6h29.326a18.688,18.688,0,0,1,18.688,18.687v.608l-48.013,0Z",
    transform: "translate(-249.2 73.806)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21217",
    "data-name": "Path 21217",
    d: "M128.639,569.511l14.78,1.811,14.023-56.144L135.629,512.5Z",
    transform: "translate(55.844 222.485)",
    fill: "#ffb6b6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21218",
    "data-name": "Path 21218",
    d: "M417.884,714.625l29.107,3.569h0a18.689,18.689,0,0,1,16.274,20.824l-.074.6-47.656-5.844Z",
    transform: "translate(-236.579 72.081)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21219",
    "data-name": "Path 21219",
    d: "M389.284,516.654s-28.684,19.6-14.343,72.666l19.4,205.964,23.042-.163,9.76-101.63,6.633-71.548,22.162,73.987L437.7,786.715l26.9,2.832,32.234-105.576L481.3,533.655Z",
    transform: "translate(-255.944 -13.861)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21220",
    "data-name": "Path 21220",
    d: "M456.625,414.032,442.04,402.3l-38.678-1.592L375.389,419.6S372.5,486.85,391.431,546.759l-9.924,25.025,99.226,12.448Z",
    transform: "translate(-254.075 -64.194)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-7)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "screenrecorder-1_svg__Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 33.177,
    cy: 33.177,
    r: 33.177,
    transform: "translate(138.102 255.767)",
    fill: "#ffb6b6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21221",
    "data-name": "Path 21221",
    d: "M435.449,339.375h-7.373a34.423,34.423,0,0,0-44.255,32.985l-11.483,37.892a7.313,7.313,0,0,0,7,9.434h5.6a16.5,16.5,0,0,0,2.873-11.491,33.907,33.907,0,0,1,2.175,7.907,13.929,13.929,0,0,1-.073,3.584h48.761a18.2,18.2,0,0,0-4.409-13.117,65.6,65.6,0,0,1,10.161,13.118h.916a7.313,7.313,0,0,0,7.313-7.312V375.228H471.3A35.853,35.853,0,0,0,435.449,339.375Z",
    transform: "translate(-255.468 -91.443)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21222",
    "data-name": "Path 21222",
    d: "M444.847,567.871a11.43,11.43,0,0,1,1.561-17.457l-10.989-39.1,20.107,6.42,7.352,36.149a11.492,11.492,0,0,1-18.032,13.991Z",
    transform: "translate(-227.947 -16.18)",
    fill: "#ffb6b6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21223",
    "data-name": "Path 21223",
    d: "M424.252,417.466l12.577-7.421s19.782-3.487,21.894,22.869,5.153,94.772,5.153,94.772l6.17,57.674-22.9,4.882-26.317-78.869Z",
    transform: "translate(-234.279 -60.208)",
    fill: "url(#screenrecorder-1_svg__linear-gradient-7)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-1_svg__Path_21224",
    "data-name": "Path 21224",
    d: "M596.216,734.809H292.184a1.434,1.434,0,1,1,0-2.868H596.216a1.434,1.434,0,0,1,0,2.868Z",
    transform: "translate(-290.75 79.598)",
    fill: "#cacaca"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenrecorder1);
export default __webpack_public_path__ + "static/media/screenrecorder-1.423dd249973f9fa875677d7c09d20239.svg";
export { ForwardRef as ReactComponent };